import BancoDoAuto25BlackBG from '@/components/organisms/BancoDoAuto25BlackBG';
import BancoDoAuto25Stack from '@/components/organisms/BancoDoAuto25Stack';
import BancoDoAuto25Video from '@/components/organisms/BancoDoAuto25Video';
import Styles from './FinanciamentoDePesados25.css';
import Head from 'next/head';
import React from 'react';
import RedButton from '@/components/atoms/RedButton';
import BancoAutoPesado from '@/components/molecules/BancoAutoPesado';
import BancoAutoFinanciePesado from '@/components/molecules/BancoAutoFinanciePesado';
import BancoAutoPesadoDesktop from '@/components/molecules/BancoAutoPesadoDesktop';
import BancoDoAutoPerguntas from '@/components/organisms/BancoDoAutoPerguntas';
import FinanciamentoDePesados25Blog from '@/components/organisms/FinanciamentoDePesados25Blog';
import { isMobile } from '../../../utils/browser';

function FinanciamentoDePesados25() {
  const faqTitle = 'Saiba mais sobre financiamento de pesados';
  const imgpng = 'assets/banco-do-auto25/img-perguntas-pesado.png';
  const imgwebp = 'assets/banco-do-auto25/img-perguntas-pesado.webp';
  const imgalt =
    'Homem branco de de camisa vermelha pesquisandi no celular mais sobre o financiamento de veiculos no Santander';
  const faqs = [
    {
      pergunta: 'O que é o financiamento de veículos pesados?',
      resposta:
        'É uma modalidade de crédito destinada a aquisição de veículos comerciais pesados, como caminhões, vans utilitárias e implementos rodoviários, como carretas e baús. O cliente escolhe as condições mediante análise de crédito e paga o valor financiado em parcelas mensais, com prazos e condições personalizados.',
    },
    {
      pergunta: 'Eu posso financiar um veículo pesado?',
      resposta:
        'São elegíveis ao financiamento de veículos pesados qualquer pessoa física ou jurídica aprovadas na análise de crédito.',
    },
    {
      pergunta: 'Como funciona o financiamento de implementos rodoviários?',
      resposta:
        'Os implementos rodoviários, como carretas e baús, são financiados como parte do pacote de aquisição de veículos como caminhões e cavalos mecânicos, desde que sejam novos.',
    },
    {
      pergunta: 'É possível financiar caminhão + implemento na mesma proposta?',
      resposta:
        'Sim, através do Santander Financiamentos é possível financiar o seu caminhão junto com um implemento sobre chassi, ou seja, para que o financiamento dos 2 bens ocorra no mesmo contrato, o implemento tem que estar sobre o chassi do caminhão. Para implementos com chassi próprio, o financiamento deverá ser feito em contratos diferentes, mas não se preocupe: é possível realizar o financiamento de um cavalo mecânico e um semirreboque juntos, procure uma de nossas lojas credenciadas e peça para falar com um especialista Santander.',
    },
    {
      pergunta: 'Que tipos de implementos rodoviários estão disponíveis para financiamento?',
      resposta:
        'Existe uma ampla variedade de implementos rodoviários novos, como carretas basculantes, baús em geral, porta-containers, entre outros que estão aptos ao financiamento através do Santander. Você pode consultar a disponibilidade dos implementos diretamente na nossa rede de lojas e concessionárias.',
    },
    {
      pergunta: 'Consigo financiar minha frota de veículos Pesados?',
      resposta:
        'Sim. Através da Financeira é possível renovar sua frota mediante análise de crédito, que considera fatores como histórico financeiro, capacidade de pagamento, entre outros fatores. É possível incluir veículos de diferentes marcas, desde que aprovados nas condições da simulação.',
    },
  ];

  return (
    <>
      <Head>
        <title>Financiamentos de Veículos Pesados | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Financiamentos de caminhões, implementos, vans e micro-ônibus! Financie um veículo pesado na Santander financiamentos. Simule agora!"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/financiamento-de-pesados.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta
          property="og:title"
          content="Financiamento de Veículos Pesados | Santander Financiamentos"
        />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/financiamento-de-pesados.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Financiamentos de caminhões, implementos, vans e micro-ônibus! Financie um veículo pesado na Santander financiamentos. Simule agora!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/assets/banco-do-auto25/banners/bg-banner-pesados.webp"
        />
        <meta
          property="og:image:alt"
          content="Homem branco de camisa vermelha com caminhão branco financiado pelo Santander ao fundo"
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Financiamento de Veículos Pesados | Santander Financiamentos"
        />
        <meta
          name="twitter:description"
          content="Financiamentos de caminhões, implementos, vans e micro-ônibus! Financie um veículo pesado na Santander financiamentos. Simule agora!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/financiamento-de-pesados.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/assets/banco-do-auto25/banners/bg-banner-pesados.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Homem branco de camisa vermelha com caminhão branco financiado pelo Santander ao fundo"
        />
        <meta property="twitter:image:type" content="image/jpeg" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <BancoDoAuto25BlackBG id="financiamento-pesado">
        <div className="container-imagem mobile">
          {/* <div className="linear-gradiente" /> */}
          <picture>
            <source type="image/webp" srcSet="assets/banco-do-auto25/financiamento-pesados.webp" />
            <source type="image/png" srcSet="assets/banco-do-auto25/financiamento-pesados.png" />
            <img
              src="assets/banco-do-auto25/financiamento-pesados.png"
              alt="Mulher Negra de camisa vermelha com Van branca financiada pelo Santander"
            />
          </picture>
        </div>
        <BancoDoAuto25Stack>
          <div className="container-imagem desktop">
            {/* <div className="linear-gradiente" /> */}
            <picture>
              <source
                type="image/webp"
                srcSet="assets/banco-do-auto25/financiamento-pesados.webp"
              />
              <source type="image/png" srcSet="assets/banco-do-auto25/financiamento-pesados.png" />
              <img
                src="assets/banco-do-auto25/financiamento-pesados.png"
                alt="Mulher Negra de camisa vermelha com Van branca financiada pelo Santander"
              />
            </picture>
          </div>
          <div className="c2c-stack-content-veiculo">
            <img src="assets/banco-do-auto25/ic_vehicle_transport_services.svg" alt="veiculo" />
            <h1 className="c2c-stack-title">Financiamento de pesados</h1>
            <p className="c2c-stack-subtitle">
              O financiamento de pesados é a opção do Santander para quem procurapor um caminhão ou
              van.
              <br />
              <br />
              Nós tornamos esse sonho possível com parcelas que cabem no seu bolso e condições
              facilitadas.
            </p>
            <RedButton href="credenciados.html" className="btn-simule">
              Consultar lojas credenciadas
            </RedButton>
          </div>
        </BancoDoAuto25Stack>
      </BancoDoAuto25BlackBG>
      {isMobile() && <BancoAutoPesado />}
      <BancoAutoFinanciePesado />
      {!isMobile() && <BancoAutoPesadoDesktop />}
      <BancoDoAutoPerguntas
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        classsection="perguntas-pesados"
      />
      <FinanciamentoDePesados25Blog />
      <style jsx>{Styles}</style>
    </>
  );
}

export default FinanciamentoDePesados25;
